<template>
  <div>
    <BaseTitle
      style="margin-bottom: 5px;"
      pageTitle="CONSULTAR USUÁRIOS DO FORNECEDOR"
    />
    <v-card outlined>
      <v-card-title>
        <v-row>
          <v-col cols="11">
            <v-text-field
              v-model="search"
              outlined
              hide-details
              label="Pesquisar"
              append-icon="mdi-magnify"
              @click:append="searchUsers(1)"
              @change="searchUsers(1)"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row v-if="view">
          <v-col>
            <v-btn class="btn-novo" @click="$router.push('usuarios/criar')">
              <span
                style="font-size: 15px; margin-right: 5px;"
                class="icon-plus-1"
              ></span>
              <span>NOVO</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row
          justify="center"
          align="center"
          v-if="users.data && users.total == 0 && !items.param"
        >
          <v-col cols="8">
            <h2 class="none-items">
              Ainda não existem usuários(as) cadastrados(as) nesta conta. Caso
              queira adicionar um, clique no botão NOVO.
            </h2>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col>
            <BaseDataTable
              disable-sort
              keyItem="id"
              pagination
              :headers="headers"
              :items="items"
              :length="this.users.last_page"
              :total="users.total"
              :page="page"
              :selectable="false"
              :loading="loading"
              @paginate="searchUsers"
              @selected="selectedItems = $event"
              @onView="viewItem"
              @onEdit="editItem"
              @onDelete="remove"
              @onStatus="setState"
            >
              <template v-slot:[`item.status`]="{ item }">
                <span v-if="item.status == 1">Ativo</span>
                <span v-else>Inativo</span>
              </template>
              <template v-slot:[`item.employee_number`]="{ item }">
                <span>{{ maskCPF(item) }}</span>
              </template>
            </BaseDataTable>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import store from "./_store";
import { mask } from "vue-the-mask";
import BaseTitle from "../../components/UI/BaseTitle.vue";
import BaseDataTable from "../../components/UI/BaseDataTable.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  directives: { mask },
  components: {
    BaseTitle,
    BaseDataTable
  },
  data() {
    return {
      loading: false,
      none: false,
      message: "",
      search: "",
      page: 1,
      headers: [
        {
          value: "actions",
          actions: [
            {
              type: "switch",
              change: "onStatus",
              value: "status",
              hide: () => this.view,
              options: { small: true, readonly: true }
            },
            {
              type: "button",
              click: "onEdit",
              icon: "icon-pencil",
              hide: () => this.view,
              options: { fab: true, icon: true, small: true }
            },
            {
              type: "button",
              click: "onView",
              icon: "icon-eye",
              options: { fab: true, icon: true, small: true }
            },
            {
              type: "button",
              click: "onDelete",
              icon: "icon-lixeira",
              tooltip: item =>
                item.processo || item.provider_register.length > 0
                  ? "Usuário editou cadastro/processo. Não pode ser excluído, só inativado."
                  : null,
              disabled: item =>
                item.processo || item.provider_register.length > 0,
              hide: () => this.view,
              options: { fab: true, icon: true, small: true }
            }
          ]
        },
        { text: "CPF", value: "employee_number" },
        { text: "Nome", value: "name" },
        { text: "Situação", value: "status" }
      ],
      items: []
    };
  },
  beforeCreate() {
    const STORE_USER = "$_user";
    if (!(STORE_USER in this.$store._modules.root._children))
      this.$store.registerModule(STORE_USER, store);
  },
  async created() {
    this.searchUsers();
  },

  computed: {
    ...mapGetters({
      me: "$_auth/me",
      users: "$_user/users"
    }),
    view() {
      return this.$can("edit");
    }
  },

  methods: {
    ...mapActions({
      getUsers: "$_user/index",
      setStatus: "$_user/setStatus",
      deleteUser: "$_user/deleteUser"
    }),
    async searchUsers(page = 1) {
      this.loading = true;
      this.page = page;

      await this.getUsers({
        search: this.search ?? null,
        page: this.page
      });

      if (this.users) {
        this.items = [];
        this.items = Object.assign(this.items, this.users.data);

        this.items.param = this.search;
      }

      this.loading = false;
    },
    viewItem(item) {
      const id = item.id ?? 0;
      this.$router.push(`usuarios/${id}/visualizar`);
    },
    editItem(item) {
      const id = item.id ?? 0;
      this.$router.push(`usuarios/${id}/editar`);
    },
    async setState(item) {
      if (item.status)
        this.message = "O usuário será Desativado. Deseja continuar?";
      else if (!item.status)
        this.message = "O usuário será Ativado. Deseja continuar?";
      await this.$store.dispatch("$_notifications/setAlert", {
        message: this.message,
        cancelTitle: "Não",
        actions: [
          {
            title: "Sim",
            action: this.setStateAction,
            param: item
          }
        ]
      });
      this.message = "";
    },

    async setStateAction(item) {
      try {
        item.status = !item.status;
        const result = await this.setStatus({
          id: item.id
        });
        await this.$store.dispatch(`$_messages/setErrors`, {
          message: result.message,
          type: "success",
          title: "Success!",
          timeout: 12000
        });
      } catch (error) {
        item.status = !item.status;
        await this.$store.dispatch(`$_messages/setErrors`, {
          message:
            error.response.data.message ??
            "Erro ao tentar alterar o status do fornecedor.",
          type: "error",
          title: "Successo!",
          timeout: 12000
        });
      }
    },

    async remove(item) {
      this.editItem = item.id;
      await this.$store.dispatch("$_notifications/setAlert", {
        message: "Este usuário será excluído. Deseja continuar?",
        cancelTitle: "Não",
        actions: [
          {
            title: "Sim",
            action: this.removeAction,
            param: item
          }
        ]
      });
    },

    async removeAction(item) {
      try {
        const result = await this.deleteUser(item.id);
        await this.$store.dispatch(`$_messages/setErrors`, {
          message: result.message ?? "OK",
          type: "success",
          title: "Successo!",
          timeout: 12000
        });
        this.searchUsers(this.page);
      } catch (error) {
        await this.$store.dispatch(`$_messages/setErrors`, {
          message: error.data.message,
          title: "Erro!",
          timeout: 12000
        });
      }
    },

    maskCPF(item) {
      var { employee_number } = item;
      if (employee_number) {
        employee_number = employee_number.replace(/\D/g, "");
        employee_number = employee_number.replace(/(\d{3})(\d)/, "$1.$2");
        employee_number = employee_number.replace(/(\d{3})(\d)/, "$1.$2");
        employee_number = employee_number.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
        return employee_number;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .btn-novo {
  background: #ebe6e6 !important;
  border: 1px solid #ffffff;
  box-sizing: border-box;
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.25);
  border-radius: 46px !important;
  padding: 0 20px 0 20px !important;
  span {
    font-weight: 300;
    font-size: 15px;
    line-height: 29px;
    text-align: center;

    color: #444444;
  }
}

.none-items {
  text-align: center;
  font-weight: 300;
  line-height: 40px;
  font-size: 27px;
}

.text-start {
  width: 250px !important;
}
</style>
